export const handleClick = (event, setAnchorEl) => {
  setAnchorEl(event.currentTarget)
}

export const handleClose = (setAnchorEl) => {
  setAnchorEl(null)
}
